import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

const routes: CustomRoute = {
	path: appPath.rentalGuide.replace(appPath.rental, ''),
	components: () => [import(/* webpackChunkName: 'rentalGuide' */ './component')],
	render: ([RentalGuide]) => <RentalGuide />,
};

export default routes;
